import React from 'react';
import  './pickListCustom.css';

export const ServicoAdicionalTemplate = servico => (
    <div className='container-item'>
        <div className="container-item-servicos">
            <i className={`pi ${servico?.icon}`} style={{ fontSize: '1em' }}></i>
            <div style={{ paddingLeft: '0.5rem' }}>{servico?.nome? servico.nome.toUpperCase() : 'SEM NOME'}</div>
        </div>
        <div className='exibicao-valor'><span >{servico?.valor? servico.valor.toLocaleString('pt-BR', { style:'currency',
            currency:'BRL' }) : new Intl.NumberFormat(
            'pt-BR',
            {
                style: 'currency',
                currency:
                    'BRL'
            }
        ).format(
            '0'
        ) }</span></div>
    </div>

);
